// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.teacher-schools-combobox .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box\n  .v-select__selections,\n.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed\n  .v-select__selections {\n    min-height: 46px;\n}\n", ""]);
// Exports
module.exports = exports;
